var _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorPicker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 49,
    viewBox: "0 0 125 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.466,
    y: 0.31,
    width: 123.659,
    height: 47.83,
    rx: 5.69,
    fill: "#fff",
    fillOpacity: 0.68
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.466,
    y: 0.31,
    width: 123.659,
    height: 47.83,
    rx: 5.69,
    stroke: "url(#paint0_linear_11_744)",
    strokeWidth: 0.62
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.156,
    y: 6,
    width: 15.009,
    height: 15.009,
    rx: 1.072,
    fill: "#030303"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.742,
    y: 9.216,
    width: 84.694,
    height: 8.577,
    rx: 2.144,
    fill: "url(#paint1_linear_11_744)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.817 37.446v-5.458h.661v2.43h2.91v-2.43h.661v5.458h-.66v-2.441h-2.91v2.441zm7.186.085q-.591 0-1.02-.26a1.75 1.75 0 0 1-.659-.736 2.5 2.5 0 0 1-.229-1.104q0-.628.23-1.108.231-.483.644-.752.415-.272.97-.272.32 0 .632.107t.567.346q.256.237.408.63.152.39.152.964v.267h-3.155v-.544h2.515q0-.346-.138-.618a1.05 1.05 0 0 0-.98-.587q-.377 0-.651.187-.271.183-.418.48a1.4 1.4 0 0 0-.147.634v.362q0 .464.16.786.162.32.45.488.288.165.67.165.247 0 .447-.069a1 1 0 0 0 .349-.213 1 1 0 0 0 .226-.357l.608.17a1.35 1.35 0 0 1-.322.544 1.6 1.6 0 0 1-.56.362 2.1 2.1 0 0 1-.749.128m3.01-4.178.982 1.673.98-1.673h.725l-1.322 2.046 1.322 2.047h-.725l-.98-1.588-.981 1.588h-.725l1.3-2.047-1.3-2.046z",
    fill: "#172B4D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.01,
    y: 27.709,
    width: 84.158,
    height: 14.473,
    rx: 1.876,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32.01,
    y: 27.709,
    width: 84.158,
    height: 14.473,
    rx: 1.876,
    stroke: "#C8D0DC",
    strokeWidth: 0.536
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.7 37.446.896-5.458h.533l-.896 5.458zm-2.483-1.514.085-.533h4.072l-.086.533zm.564 1.514.896-5.458h.533l-.896 5.458zm-.245-3.411.086-.533h4.072l-.086.533zm6.77-2.047v5.458h-.66V32.68h-.032l-1.333.885v-.672l1.365-.906zm3.319 5.532a2.3 2.3 0 0 1-.97-.194 1.6 1.6 0 0 1-.654-.541 1.36 1.36 0 0 1-.231-.789 1.45 1.45 0 0 1 .514-1.132q.243-.2.541-.254v-.032a1.05 1.05 0 0 1-.624-.44 1.33 1.33 0 0 1-.229-.775 1.3 1.3 0 0 1 .21-.743q.214-.328.587-.517.376-.19.855-.19.476 0 .848.19.373.189.586.517.216.327.219.743-.003.434-.237.776-.232.338-.616.44v.031q.296.053.533.254.237.196.378.493.142.292.144.64a1.4 1.4 0 0 1-.24.788 1.6 1.6 0 0 1-.653.541q-.415.194-.962.194m0-.586q.37 0 .639-.12a.95.95 0 0 0 .416-.338.9.9 0 0 0 .149-.512 1 1 0 0 0-.16-.546 1.1 1.1 0 0 0-.429-.373 1.35 1.35 0 0 0-.615-.136q-.35 0-.624.136-.271.136-.43.373a.96.96 0 0 0-.151.546.9.9 0 0 0 .141.512.95.95 0 0 0 .418.338q.273.12.645.12m0-2.59q.292 0 .52-.117a.9.9 0 0 0 .359-.328.93.93 0 0 0 .133-.493.9.9 0 0 0-.13-.483.85.85 0 0 0-.355-.32 1.15 1.15 0 0 0-.528-.114q-.306 0-.535.115a.83.83 0 0 0-.355.32.9.9 0 0 0-.122.482.9.9 0 0 0 .125.493q.13.21.36.328.23.117.528.117m4.613-2.43q.336.002.672.127.336.126.613.416.276.288.445.786t.168 1.25q0 .727-.139 1.293-.135.561-.394.948a1.75 1.75 0 0 1-.624.587q-.365.2-.826.2-.459 0-.818-.182a1.6 1.6 0 0 1-.587-.509 1.8 1.8 0 0 1-.29-.76h.65q.088.376.35.622.263.242.695.242.63 0 .997-.551.367-.552.367-1.56h-.042q-.15.225-.355.387a1.56 1.56 0 0 1-.989.338q-.469 0-.86-.231a1.76 1.76 0 0 1-.624-.643 1.9 1.9 0 0 1-.232-.938q0-.502.224-.916.227-.419.634-.667a1.8 1.8 0 0 1 .965-.24m0 .586q-.335 0-.605.168-.266.166-.423.447a1.26 1.26 0 0 0-.155.621q0 .342.15.621t.412.443q.264.162.6.162a1.13 1.13 0 0 0 .853-.373q.165-.176.258-.397a1.22 1.22 0 0 0-.061-1.066 1.2 1.2 0 0 0-.421-.453 1.1 1.1 0 0 0-.608-.173m4.726 5.02q-.603 0-1.026-.327-.425-.33-.648-.957-.225-.63-.224-1.519 0-.885.224-1.511.227-.63.65-.96a1.6 1.6 0 0 1 1.024-.333q.597 0 1.02.334.428.33.65.959.228.626.227 1.511 0 .89-.224 1.519-.224.626-.647.957-.424.328-1.026.328m0-.586q.597 0 .927-.575.33-.576.33-1.642 0-.71-.151-1.207-.15-.498-.432-.76a.95.95 0 0 0-.674-.26q-.592 0-.925.583-.333.58-.333 1.644 0 .709.15 1.205.149.495.428.754a.97.97 0 0 0 .68.258m3.006.512v-5.458h3.272v.586h-2.611v1.845h2.366v.586h-2.366v2.44zm4.404 0v-5.458h3.273v.586h-2.612v1.845H88.4v.586h-2.367v2.44z",
    fill: "#172B4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_744",
    x1: 4.355,
    y1: 0,
    x2: 73.094,
    y2: 87.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_744",
    x1: 31.742,
    y1: 13.505,
    x2: 116.435,
    y2: 13.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#FF8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#14FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#00A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#0500FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#AD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#FF00C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_744"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.089 30.446h32v9h-32z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPicker);
export default __webpack_public_path__ + "static/media/color-picker.c240d9ad521e2a0244114961ace3cd3e.svg";
export { ForwardRef as ReactComponent };